export const planConverter = {
  fromFirestore: (snapshot, options) => {
    const plan = snapshot.data(options);
    const id = snapshot.id;

    return {
      _id: id,
      applicationId: plan.application_id,
      collectorId: plan.collector_id,
      currencyId: plan.auto_recurring?.currency_id,
      frecuencyType: plan.auto_recurring?.frequency_type,
      initPoint: plan.init_point,
      monthlyCredits: plan.monthly_credits,
      name: plan.plan_name,
      price: plan.auto_recurring?.transaction_amount,
      reason: plan.reason,
      status: plan.status,
    };
  },
  toFirestore: (plan) => {
    delete plan._id;
    return {
      application_id: plan.applicationId,
      auto_recurring: {
        currency_id: plan.currency,
        frecuency: 1,
        frequency_type: plan.frecuencyType,
        transaction_amount: plan.amount,
      },
      collector_id: plan.currencyId,
      init_point: plan.initPoint,
      monthly_credits: plan.monthlyCredits,
      plan_name: plan.name,
      reason: plan.reason,
      status: plan.status,
    };
  },
};
